import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { formatChatTimestamp } from 'app/utils/chat/chatUtils';
import { IconButton, Typography, Tooltip as PlatformUITooltip } from '@mic3/platform-ui';

import Tooltip from 'app/components/atoms/Tooltip/Tooltip';
import Icon from 'app/components/atoms/Icon/Icon';
import DotMenu from 'app/components/molecules/DotMenu/DotMenu';
import MessageReadTick from 'app/components/atoms/MessageReadTick/MessageReadTick';

const ItemHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    & .MuiIconButton-root {
        padding: 4px;
    }
`;

const MessageBodyHeaderWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const MessageBodyHeader = styled(Typography)`
    color: ${({ theme }) => theme.material.palette.text.disabled};
    && {
        font-size: 12px;
        margin-bottom: ${({ type }) => (type ? '0px' : '4px')};
        color: ${({ theme }) => theme.material.colors.text.caption};
    }
`;

const ActionsWrapper = styled.div`
    display: grid;
    grid-template-areas: 'stack';
    align-items: center;
    justify-items: end;
    min-width: 24px;
    min-height: 24px;
`;

const ReadTickSlot = styled.span`
    grid-area: stack;
    display: inline-flex;
    justify-content: flex-end;
`;

const ActionsCluster = styled.span`
    grid-area: stack;
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
`;

const ChatItemHeader = ({
    name,
    createDate,
    editedDate,
    userEditor,
    actionsRef,
    pickerAnchor,
    openPicker,
    menuItems,
    onDotMenuClick,
    canReact = true,
    unread,
}) => (
    <ItemHeader>
        <MessageBodyHeaderWrapper>
            <MessageBodyHeader variant="body1">
                {name} {formatChatTimestamp(createDate)}
                {'   '}
            </MessageBodyHeader>
            {editedDate && (
                <Tooltip title={`edited at ${formatChatTimestamp(editedDate)} by ${userEditor}`}>
                    <Icon name="pencil" size="sm" />
                </Tooltip>
            )}
        </MessageBodyHeaderWrapper>
        <ActionsWrapper ref={actionsRef}>
            <ReadTickSlot className="message-read-tick-slot">
                <MessageReadTick unread={unread} />
            </ReadTickSlot>
            <ActionsCluster className={`message-actions${pickerAnchor ? ' is-open' : ''}`}>
                {canReact && (
                    <PlatformUITooltip title="Add reaction" aria-label="add-reaction">
                        <IconButton onClick={openPicker}>
                            <Icon name="emoticon-outline" size="md" />
                        </IconButton>
                    </PlatformUITooltip>
                )}
                {menuItems?.length ? <DotMenu onItemClick={onDotMenuClick} items={menuItems} tooltipTitle="More Options" /> : null}
            </ActionsCluster>
        </ActionsWrapper>
    </ItemHeader>
);

ChatItemHeader.propTypes = {
    name: PropTypes.string,
    createDate: PropTypes.any,
    editedDate: PropTypes.any,
    userEditor: PropTypes.string,
    actionsRef: PropTypes.any,
    pickerAnchor: PropTypes.any,
    openPicker: PropTypes.func.isRequired,
    menuItems: PropTypes.array.isRequired,
    onDotMenuClick: PropTypes.func.isRequired,
    canReact: PropTypes.bool,
    unread: PropTypes.bool,
};

export default memo(ChatItemHeader);
